"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var BreadcrumbHelper = {
  crumbs: [],
  callables: [],
  addCrumb: function addCrumb(label) {
    var link = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    this.crumbs.push({
      label: label,
      link: link
    });
    this.updated();
  },
  setLastCrumb: function setLastCrumb(label) {
    if (this.crumbs.length > 0) {
      this.crumbs[this.crumbs.length - 1].label = label;
      this.updated();
    }
  },
  setCrumbs: function setCrumbs(crumbs) {
    this.crumbs = crumbs;
    this.updated();
  },
  clearCrumbs: function clearCrumbs() {
    this.setCrumbs([]);
  },
  getCrumbs: function getCrumbs() {
    return this.crumbs;
  },
  onUpdate: function onUpdate(callable) {
    this.callables.push(callable);
  },
  updated: function updated() {
    for (var i = 0; i < this.callables.length; i++) {
      var callable = this.callables[i];
      callable(this.crumbs);
    }
  }
};
var _default = BreadcrumbHelper;
exports["default"] = _default;